export default __webpack_public_path__ + "static/media/piece.f5a06c59.flac";